import { trackEvent } from 'dibs-tracking';

import { isPageType } from '../../global/notifications/pageTypeHelper.es';
import { PAGE_TYPE, BROWSE_TYPES } from '../../global/constants/pageTypes.es';

function getLabel() {
    if (isPageType(PAGE_TYPE.PDP)) {
        return 'pdp';
    } else if (isPageType(BROWSE_TYPES)) {
        return 'search/browse';
    } else if (isPageType(PAGE_TYPE.FAVORITES)) {
        return 'my favorites';
    }
    return void 0;
}

function trackFolderEvent(action, noteIncluded = false) {
    const label = getLabel();

    if (label) {
        trackEvent({
            label,
            action,
            category: "item favoriting",
            value: noteIncluded ? 1 : 0
        });
    }
}

export function trackFolderClick() {
    trackFolderEvent("item favoriting folder clicked");
}

export function trackItemRemoved() {
    trackFolderEvent("item removed from folder");
}

export function trackItemAdded(noteIncluded = false) {
    trackFolderEvent("item added into folder", noteIncluded);
}

export function trackFolderCreated(noteIncluded = false) {
    trackFolderEvent("item favoriting folder created", noteIncluded);
}

export default {
    trackFolderClick,
    trackItemRemoved,
    trackItemAdded,
    trackFolderCreated
};



// WEBPACK FOOTER //
// ./assets/js/favorites/shared/folderTracking.es.js